import React from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'

import Button from '../../atoms/Button/Button'

import ButtonGroup from '../../atoms/Button/ButtonGroup'

const BedroomButtonGroup = ({ currentRefinement, items, refine, type = 'gray700' }) => (
  <ButtonGroup>
    {items
      .sort((a, b) => a.label - b.label)
      .map((option, i) => (
        <Button
          key={i}
          outline={currentRefinement.indexOf(option.label) === -1}
          type={currentRefinement.indexOf(option.label) > -1 ? 'primary' : type}
          onClick={() => refine(option.value)}
        >
          {option.label === '0' ? 'Studio' : option.label}
        </Button>
      ))}
  </ButtonGroup>
)

export default connectRefinementList(BedroomButtonGroup)
